import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1083ed0e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1083ed0e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083ed0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1083ed0e')) {
      api.createRecord('1083ed0e', component.options)
    } else {
      api.reload('1083ed0e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1083ed0e&scoped=true", function () {
      api.rerender('1083ed0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/userInfo/index.vue"
export default component.exports